import { render } from "./MallFooter.vue?vue&type=template&id=133cc0cb&scoped=true"
const script = {}

import "./MallFooter.vue?vue&type=style&index=0&id=133cc0cb&scoped=true&lang=css"
import "./MallFooter.vue?vue&type=style&index=1&id=133cc0cb&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133cc0cb"]])

export default __exports__